/* eslint-disable no-unused-vars */
import React from 'react';
import style from './searchOverlay.module.scss';

export default function SearchOverlay({
  isOpen,
  setIsOpen,
}: {
  isOpen: boolean;
  setIsOpen: (value: React.SetStateAction<boolean>) => void;
}) {
  return (
    <>
      {isOpen ? (
        <div className={style.container} onClick={() => setIsOpen(false)}></div>
      ) : (
        ''
      )}
    </>
  );
}
